import React from 'react';

const APP_STORE_URL = 'https://apps.apple.com/us/app/smpw-scheduler/id6762612656';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=io.github.branleeharris.smpwscheduler';

function AppleGlyph({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={className}
      fill="currentColor"
    >
      <path d="M16.365 1.43c0 1.14-.43 2.23-1.13 3.04-.76.9-1.99 1.6-3.08 1.52-.13-1.12.45-2.27 1.13-3.04.78-.86 2.1-1.5 3.08-1.52zM20.5 17.45c-.55 1.21-.81 1.75-1.52 2.83-.99 1.51-2.39 3.39-4.12 3.4-1.54.01-1.94-1-4.04-.99-2.1.01-2.54 1.01-4.08.99-1.74-.02-3.06-1.71-4.05-3.22-2.77-4.22-3.07-9.18-1.36-11.81 1.21-1.86 3.13-2.95 4.93-2.95 1.84 0 2.99 1.01 4.51 1.01 1.47 0 2.37-1.01 4.49-1.01 1.6 0 3.3.87 4.51 2.38-3.97 2.17-3.32 7.85.73 9.37z" />
    </svg>
  );
}

function PlayTriangleGlyph({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <defs>
        <linearGradient id="smpw-play-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#34d399" />
          <stop offset="100%" stopColor="#0ea5e9" />
        </linearGradient>
      </defs>
      <path
        fill="url(#smpw-play-gradient)"
        d="M5 3.5v17a1 1 0 0 0 1.5.87l14-8.5a1 1 0 0 0 0-1.74l-14-8.5A1 1 0 0 0 5 3.5z"
      />
    </svg>
  );
}

export default function StoreBadge({ platform, size = 'default', className = '' }) {
  const isIos = platform === 'ios';
  const href = isIos ? APP_STORE_URL : PLAY_STORE_URL;
  const title = isIos ? 'App Store' : 'Google Play';
  const kicker = isIos ? 'Download on the' : 'GET IT ON';
  const label = isIos ? 'Download on the App Store' : 'Get it on Google Play';

  const isCompact = size === 'compact';
  const padding = isCompact ? 'px-3 py-2' : 'px-5 py-3';
  const gap = isCompact ? 'gap-2' : 'gap-3';
  const titleSize = isCompact ? 'text-sm' : 'text-base';
  const kickerSize = isCompact ? 'text-[9px]' : 'text-[10px]';
  const iconSize = isCompact ? 'h-5 w-5' : 'h-7 w-7';

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className={`group inline-flex items-center ${gap} rounded-xl bg-gray-900 ${padding} text-white shadow-card transition hover:-translate-y-0.5 hover:shadow-card-hover dark:bg-white dark:text-gray-900 ${className}`}
    >
      {isIos ? (
        <AppleGlyph className={iconSize} />
      ) : (
        <PlayTriangleGlyph className={iconSize} />
      )}
      <span className="flex flex-col text-left leading-tight">
        <span className={`${kickerSize} uppercase tracking-wider opacity-70`}>
          {kicker}
        </span>
        <span className={`font-display ${titleSize} font-semibold`}>{title}</span>
      </span>
    </a>
  );
}
